/* Core / critical JS only - loaded on every page for rendering priority elements */
/* Keep it as small as possible! */

/* global gsap */

document.addEventListener("DOMContentLoaded", function (event) {

    //Nav controls, etc.

    const hamburger = document.getElementById('navtoggler');
    const navMenu = document.getElementById('mainnav-holder');
    const navBar = document.getElementById('main-navbar');

    // Toggle main menu
    const menuToggle = () => {
        hamburger.classList.toggle("active");
        navMenu.classList.toggle("active");
        navBar.classList.toggle("active");
    }
    hamburger.addEventListener('click', menuToggle, false);

});



